<ds-card [title]="'finding_details' | translate" [variant]="DsCardVariant.StatusChip" data-test-id="finding-metadata-card">
  <ng-container ds-card-body>
    <div class="finding-metadata-card-body">
      <div class="d-flex flex-wrap gap-2 align-items-end margin-bottom-md">
        @for (group of chipGroups; track group.labelKey) {
          @for (chip of group.chips; track chip.text; let first = $first) {
            <div class="d-flex flex-column" [attr.data-test-id]="'metadata-chip-group-' + group.labelKey">
              @if (first) {
                <label class="finding-metadata-chip-title margin-bottom-xs">{{ group.labelKey | translate }}</label>
              }
              <ds-chip
                [text]="chip.text"
                [colorVariant]="chip.colorVariant"
                [showIcon]="chip.showIcon"
                [iconName]="chip.iconName"
                [iconStyle]="chip.iconStyle"
                [iconColor]="chip.iconColor"
                [iconPosition]="chip.iconPosition"
              ></ds-chip>
            </div>
          }
        }
      </div>

      @if (criteriaAndStandardLinks.length) {
        <div class="margin-bottom-sm" data-test-id="criteria-and-standard">
          <label class="finding-metadata-chip-title margin-bottom-xs">{{
            'audit_rule_property_success_criteria_criteria_and_standard' | translate
          }}</label>
          <ul class="list-unstyled margin-bottom-00 criteria-and-standard-list">
            @for (link of criteriaAndStandardLinks; track link.text; let last = $last) {
              <li class="criteria-and-standard-list-item">
                <ds-link [href]="link.href" [external]="true" [ariaLabel]="link.ariaLabel">{{ link.text }}</ds-link>
                @if (!last) {
                  <div class="finding-metadata-divider-line"></div>
                }
              </li>
            }
          </ul>
        </div>
      }

      @if (issue?.[$flaw._id]) {
        <div class="finding-metadata-divider-line"></div>

        <label class="finding-history-title margin-bottom-sm">{{ 'findings_history_label' | translate }}</label>
        <div class="d-flex flex-column gap-3" data-test-id="findings-history">
          <div class="finding-history-item" data-test-id="first-seen">
            <ds-icon class="finding-history-item-icon" [icon]="Icons.CalendarDays"></ds-icon>
            <div class="finding-history-item-title">{{ 'finding_first_seen_label' | translate }}</div>
            <div class="finding-history-item-value">{{ issue[$flaw.firstFound].date | prettifyDate }}</div>
          </div>
          <div class="finding-history-item" data-test-id="last-seen">
            <ds-icon class="finding-history-item-icon" [icon]="Icons.Clock"></ds-icon>
            <div class="finding-history-item-title">{{ 'finding_last_seen_label' | translate }}</div>
            <div class="finding-history-item-value">{{ issue[$flaw.lastFound].date | prettifyDate }}</div>
          </div>
          @if (issue[$flaw.mobileOccurrenceCount]?.length) {
            <div class="finding-history-item" data-test-id="current-count">
              <ds-icon class="finding-history-item-icon" [icon]="Icons.ChevronsRight"></ds-icon>
              <div class="finding-history-item-title">{{ 'finding_current_count_label' | translate }}</div>
              <div class="finding-history-item-value">{{ getCurrentMobileOccurrenceCount() }}</div>
            </div>
            <div class="finding-history-item" data-test-id="previous-count">
              <ds-icon class="finding-history-item-icon" [icon]="Icons.ChevronsLeft"></ds-icon>
              <div class="finding-history-item-title">{{ 'finding_previous_count_label' | translate }}</div>
              <div class="finding-history-item-value">{{ getPreviousMobileOccurrenceCount() }}</div>
            </div>
          }
          <div class="finding-history-item" data-test-id="previous-status">
            <ds-icon class="finding-history-item-icon" [icon]="Icons.Tag"></ds-icon>
            <div class="finding-history-item-title">{{ 'finding_previous_status_label' | translate }}</div>
            <div class="finding-history-item-value">{{ 'label_' + getFlawPreviousStatus() | translate }}</div>
          </div>
          <div class="finding-history-item" data-test-id="times-seen">
            <ds-icon class="finding-history-item-icon" [icon]="Icons.Eye"></ds-icon>
            <div class="finding-history-item-title">{{ 'finding_times_seen_label' | translate }}</div>
            <div class="finding-history-item-value">{{ issue.flawOccurrence }}</div>
          </div>
        </div>
      }
    </div>
  </ng-container>
</ds-card>
